module.exports = __webpack_public_path__ + "static/media/bg_purple.69968440.jpeg";